<template lang="html">
  <div v-if="pageData"
       class="Dropdown"
       :class="{
        showDropdown: $store.state.showDropdown,
        PageSlideLeft: showNavigation,
      }">
    <div class="DropdownSelect">
      <div class="Entry"
           @click="toggleContent()">
        {{ pageData.options.dropdown.title }}
      </div>

      <div class="DropdownTrigger">
        <img v-if="!$store.state.openDropdown"
             src="@/assets/img/icons/ChevronDown.png"
             @click="toggleContent()"
             alt="Open Dropdown" />
        <img v-else
             src="@/assets/img/icons/ChevronUp.png"
             alt="Close Dropdown"
             @click="toggleContent()" />
      </div>

      <div class="pointer">
        <img src="@/assets/img/icons/MenuTriggerBlack.png"
             alt="Trigger Dropdown"
             @click="toggleNavigation()" />
      </div>
    </div>
    <div v-if="$store.state.openDropdown"
         class="DropdownContent">
      <div v-for="link in sortedLinks"
           class="Entry"
           v-bind:key="link.route">
        <router-link :to="{ name: link.route, params: {} }"
                     class="EntryLink"
                     v-if="link.route">
          {{ link.title }}
        </router-link>

        <router-link :to="{ path: link.path }"
                     class="EntryLink"
                     v-else>
          {{ link.title }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/dropdown.css";

import { mapGetters } from "vuex";

export default {
  props: {},
  data() {
    return {
      scrollTimeout: null,
    };
  },
  computed: {
    ...mapGetters(["pageData", "showNavigation"]),
    pageContainer() {
      return document.querySelector(".Page");
    },
    sortedLinks() {
      return this.pageData.options.dropdown.links.filter(
        (link) => link.route != this.$route.name
      );
    },
    loadedTitle() {
      return this.$store.state.loadedTitle;
    },
  },
  watch: {
    loadedTitle() {
      if (this.loadedTitle == true) {
        this.createObserver();
      }
    },
  },
  mounted() {
    // Add scroll listener to handle scroll-to-top case
    window.addEventListener('scroll', this.onScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    onScroll() {
      // Throttle scroll events to avoid conflicts
      if (this.scrollTimeout) return;
      
      this.scrollTimeout = setTimeout(() => {
        // Only hide dropdown when scrolled to top
        if (window.scrollY <= 10) {
          this.$store.state.showDropdown = false;
          this.$store.state.openDropdown = false;
        }
        this.scrollTimeout = null;
      }, 50);
    },
    toggleNavigation() {
      this.$store.state.showNavigation = !this.$store.state.showNavigation;
    },
    createObserver() {
      const title = document.querySelector(".Title");
      let options = {
        root: null,
        threshold: 0.1,
      };

      let observer = new IntersectionObserver(this.toggleDropdown, options);
      observer.observe(title);
    },
    toggleDropdown(e) {
      const intersecting = e[0].isIntersecting;
      if (!intersecting) {
        this.$store.state.showDropdown = true;
      } else {
        this.$store.state.showDropdown = false;
        this.$store.state.openDropdown = false;
      }
    },
    toggleContent() {
      this.$store.state.openDropdown = +!this.$store.state.openDropdown;
    },
  },
};
</script>
